module.exports = __webpack_public_path__ + "static/media/mt.01f05537.svg";